module.exports = __webpack_public_path__ + "static/media/app-bar-logo.f7e2ba1e.svg";